<div class="tw-flex tw-items-center tw-gap-3">
  <div
    class="tw-border tw-h-14 tw-w-14 tw-rounded-full {{
      !userData?.imageSrc ? 'tw-bg-blue-500 tw-border-blue-500' : ''
    }}"
  >
    @if (userData?.imageSrc) {
      <img
        class="tw-rounded-full tw-h-full"
        [src]="$safeNavigationMigration(userData?.imageSrc)"
        [alt]="userData?.name ?? 'CG'"
      />
    } @else {
      <div class="tw-flex tw-h-full tw-text-white">
        <div class="tw-m-auto tw-font-extrabold">
          {{ $safeNavigationMigration(userData?.name) | nameSignature }}
        </div>
      </div>
    }
  </div>
  @if (userData?.name && showName) {
    <div class="tw-text-neutral-800 tw-font-normal">
      {{ userData?.name }}
    </div>
  }
</div>
